import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const ServicesSection = () => {
  return (
    <>
      <div className="row justify-content-center pb-2">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <h2>Services</h2>
        </div>
      </div>
      <div className="row justify-content-center pb-4">
        <div className="col-sm-12 col-md-4 col-lg-4 pt-4">
          <StaticImage
            className="other-servicesImg"
            src="../../../assets/images/kmc-images/OtherServices/Laboratory-Facility.png"
            alt="Laboratory Services"
          />
          <div className="others-lists">
            <h2>Laboratory Services</h2>
            <p className="other-content">
              The lab facility at this centre is advanced with five-part Coulter
              counter, biochemistry analyser, hormone analyser, point of care
              tests like viral screening including COVID rapid antigen.
              Haematology reports issued by qualified senior pathologist and are
              very accurate with turnaround time of one hour. Our centre has
              ECG, cardiac markers testing, to triage patients with chest pain.
              Lab Timings: 8:00 AM – 4:00 PM
            </p>
          </div>
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4 pt-4">
          <StaticImage
            className="other-servicesImg"
            src="../../../assets/images/kmc-images/OtherServices/COVID.png"
            alt="COVID RT-PCR Testing"
          />
          <div className="others-lists">
            <h2>COVID RT-PCR Testing</h2>
            <p className="other-content">
              KMC also conducts COVID RT PCR Tests
            </p>
          </div>
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4 pt-4">
          <StaticImage
            className="other-servicesImg"
            src="../../../assets/images/kmc-images/OtherServices/MaskGroup4.png"
            alt="ECG, Cardiac Markers"
          />
          <div className="others-lists">
            <h2>ECG, Cardiac Markers</h2>
            <p className="other-content">
              we have onsite I-chroma analyser to check the high sensitivity
              troponin to detect any heart stroke (MI) We have ECG for
              evaluation of chest pain along with Lab testing of the cardiac
              markers high sensitive Troponin to detect MI( Heart stroke )
            </p>
          </div>
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4 pt-4">
          <StaticImage
            className="other-servicesImg"
            src="../../../assets/images/kmc-images/OtherServices/MaskGroup5.png"
            alt="Day-care ward"
          />
          <div className="others-lists">
            <h2>Day-care ward</h2>
            <p className="other-content">
              Day care ward has with 12 beds and two ICU beds with oxygenators
              bedside cardiac monitors, crash cart, and defibrillator 24-hour
              ambulance facility
            </p>
          </div>
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4 pt-4">
          <StaticImage
            className="other-servicesImg"
            src="../../../assets/images/kmc-images/OtherServices/MaskGroup10.png"
            alt="Radiology : Digital X ray"
          />
          <div className="others-lists">
            <h2>Radiology : Digital X ray</h2>
            <p className="other-content">
              We have digital X ray as of now . We are hiring a full time
              radiologist and the process of procurement of ultrasound machine
              has started.{" "}
            </p>
          </div>
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4 pt-4">
          <StaticImage
            className="other-servicesImg"
            src="../../../assets/images/kmc-images/OtherServices/Ambulance.png"
            alt="24 Hour Ambulance Facility"
          />
          <div className="others-lists otherservice-height">
            <h2>24 Hour Ambulance Facility</h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServicesSection;
